module.exports = __webpack_public_path__ + "static/media/Profile-1-ss-art.e044e51c.png";